import React, { useState, useEffect } from "react";
import axios from 'axios';
import MoonLoader from "react-spinners/MoonLoader";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";

import Navbar from '../components/Navbar/Navbar';
import PageTitle from '../components/PageTitle/PageTitle';
import Footer from '../sections/Footer/Footer';
import BlogCard from '../components/BlogCard/BlogCard';
import BlogData from '../sections/Blogs/BlogData';

import Breadcrumbs from "../components/BreadCrumbs/Breadcrumbs";

const Meta = styled.a`
  ${tw` no-underline cursor-pointer bg-transparent p-2 rounded-lg text-primary-700 border border-primary-700 font-medium text-base flex items-center leading-none last:mr-0 inline-block hover:bg-primary-700 hover:text-white hover:border-primary-700`}
  
  svg {
    ${tw`w-4 h-4 mr-1`}
  }
`
const ButtonContainer =  styled.div`${tw `flex justify-center items-center w-full`}`;
const LoadMoreButton =  styled.button`${tw `mt-16 uppercase mx-auto font-bold text-base text-white px-6 py-2 rounded-full border bg-secondary-600 hover:bg-primary-600`}`;


const override = {
    display: "block",
    margin: "250px auto",
    borderColor: "#3b82f6",
  };

const heading = {
    title:'Tin tức',
    description: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.'
}

const BlogsPageTinTuc = ({categories}) => {

    const [tabIndex, setTabIndex] = useState(0);
  
    const [error, setError] = useState(null);
    const [categoryName, setCategoryName] = useState(null);
    const [posts, setPosts] = useState([])
    const [isLoading, setIsLoading] = useState(true)
  
    const [visible, setVisible] = useState(7);
  
    const [activeIndex, setActiveIndex] = useState(-1)
  
    const onLoadMoreClick = () => {
      setVisible(v => v + 6);
    };
  
    useEffect(() => {
      if (categoryName) {
        axios
        .get(`${process.env.REACT_APP_BACKEND}/api/bai-viets?populate=*&pagination[limit]=${visible}&sort[0]=createdAt:desc&filters[$and][0][loai_bai_viets
][ten_loai_bai_viet][$eq]=${categoryName}`)
        .then(({ data }) => {setPosts(data.data); setIsLoading(false);})
        .catch((error) => setError(error));
      } else {
        axios
        .get(`${process.env.REACT_APP_BACKEND}/api/bai-viets?populate=*&pagination[limit]=${visible}&sort[0]=createdAt:desc`)
        .then(({ data }) => {setPosts(data.data); setIsLoading(false);})
        .catch((error) => setError(error));
      }
      
    }, [visible, categoryName]);
    
    const handleClick = (value) =>{
      setActiveIndex(value)   
    }
    
    return (
        <>
            <Navbar />
            <div className="pt-40 px-2 md:px-2 container" >
              <div className='flex flex-col justify-start px-2'>
                <div className='breadcrumb mb-12 '>
                    <Breadcrumbs />
                </div>
                <div className='title-container'>
                    <h2 className='text-4xl md:text-6xl font-bold'>Tin tức</h2>
                </div>
              </div>
              { !isLoading ? 
                  <section className='pb-70'>
                      <div className="container ">
                          <div className="mb-5 flex flex-wrap items-center gap-2 mt-16">
                              <p className="font-semibold text-base text-dark-500 mr-1">Danh mục:</p>
                              <Meta onClick={() => {setCategoryName(null); handleClick();}} href='' className={activeIndex === -1 ? "category-selected" :""}>
                                Tất cả bài viết
                              </Meta>
                              {categories.map((category, index) => (
                                <Meta key={index} onClick={() => {setCategoryName(category.attributes.ten_loai_bai_viet); handleClick(index);}} className={index === activeIndex ? "category-selected" :""} id={`button-${index}`}>
                                  <div>{category.attributes.ten_loai_bai_viet}</div>
                                </Meta>
                              ))}
                          </div>
                          <div className="row">
                              {
                                  posts.slice(0, visible).map((post, index) => (
                                  <BlogCard key={index} post={post}/>
                              ))}
                          </div>
                      </div>
                      <ButtonContainer>
                        <LoadMoreButton onClick={onLoadMoreClick}>Xem Thêm</LoadMoreButton>
                      </ButtonContainer>
                  </section>
                  :
                  <MoonLoader 
                  cssOverride={override}
                  color="#4cb269"
                  loading={true}
                  size={50}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                  />
              }
            </div>

            <Footer />
        </>
    );
};

export default BlogsPageTinTuc;